import { InheritanceModes } from "../stores/models/constants/InheritanceModes";
import { IInheritanceResolver } from "./_interfaces/IInheritanceResolver";

export class InheritanceResolver implements IInheritanceResolver {
    
    /**
     * Resolves multiple sets of values down to one set following inheritance rules.
     * @param levels Starting at the least specific level of an inheritance tree and moving toward the most specific level, an array that specifies the values and inheritance mode at each level.
     */
    resolve<T>(levels: { mode: InheritanceModes; values: T[]; }[]): T[] {
        let result: T[] = [];

        for (let i = 0; i < levels.length; i++) {
            const currentLevel = levels[i];

            switch (currentLevel.mode) {
                case InheritanceModes.Clear:
                    result = [];
                    break;
                case InheritanceModes.Replace:
                    result = [...currentLevel.values];
                    break;
                case InheritanceModes.Append:
                    result.push(...currentLevel.values);
                    break;
                case InheritanceModes.Inherit:
                    break;
            }
        }
        
        return result;
    }

}